import {memo} from 'react'

function Error()
{
    return (
        <h1>Error</h1>
    )
}

export default memo(Error)